export default () => {
  return window.innerWidth < 992;
}
